<template>
  <div>
    <a-form :form="form" ref="form">
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Date of Addendum">
            <a-date-picker
              placeholder="Select Date"
              :disabled="mode === 'Edit'"
              :format="getDefaultDateFormat"
              v-decorator="[
                'date_of_addendum',
                {
                  rules: [{ required: true }],
                   initialValue: moment(initialData.informasi.date_of_addendum),
                },
              ]"
            />
          </a-form-item>
          <!-- <a-form-item label="Type of Transaction">
            <a-radio-group
                    buttonStyle="solid"
                    v-decorator="['jns_transaksi',{rules: [{ required: true }],initialValue: initialData.informasi.jns_transaksi,
                },
              ]"
                    ref="site"
                    @change="handleJenisTransaksi"
                    :disabled="triggered.disabledpowo"
            >
              <a-radio-button value="po" ref="Radio1">PO</a-radio-button>
              <a-radio-button value="wo" ref="Radio2">WO</a-radio-button>
            </a-radio-group>

          </a-form-item>
          <a-form-item label="No PO / WO">
            <v-select
                    :loading="no_po_wo.length >= 0 ? false:true"
                    class="m-select"
                    :clearable="false"
                    @input="handleNoPoWo"
                    :options="no_po_wo"
                    v-model="no"
                    label="no_transaksi"
                    :disabled="jenis_transaksi!=null || triggered.disabledpowo"
            >
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner" />
              </template>
            </v-select>
          </a-form-item> -->
          <a-form-item label="Id Invoice" hidden>
              <a-input v-decorator="['id_invoice_ap_ad', { rules: [{ required: false }], initialValue: initialData.informasi.id_invoice_ap_ad }]"
              disabled
              ></a-input>
            </a-form-item>
            <a-form-item label="No Invoice">
              <a-input v-decorator="['no_invoice_ap_ad', { rules: [{ required: false }], initialValue: initialData.informasi.no_invoice_ap_ad }]"
              disabled
              ></a-input>
            </a-form-item>
          <a-form-item label="Supplier">
            <a-input v-decorator="['supplier',{rules: [{ required: false }],initialValue: initialData.informasi.supplier}]"
            disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="Currency From">
            <a-select
              v-decorator="['currency_from', {rules: [{required: true}], initialValue: initialData.informasi.currency_from}]"
              disabled
            >
              <a-select-option
                v-for="item in getAllMataUang"
                :key="item.code"
                :value="item.code"
              >{{item.code}} - {{item.currency}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Account Bank Number">
            <a-input v-decorator="['account_bank_number',{rules: [{ required: true }],initialValue: initialData.informasi.account_bank_number }]"
            disabled
            ></a-input>
          </a-form-item>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="No Invoice">
                <a-input v-decorator="['no_invoice',{rules: [{ required: true }],initialValue: initialData.informasi.no_invoice}]"
                disabled
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="No Tracking">
                <a-input v-decorator="['no_tracking',{rules: [{ required: false }],initialValue: initialData.informasi.no_tracking}]"
                disabled
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="PIB">
            <a-radio-group
                disabled
                buttonStyle="solid"
                v-decorator="['pib',{rules: [{ required: true }],initialValue: initialData.informasi.pib,},]"
            >
              <a-radio-button :value="true" >Yes</a-radio-button>
              <a-radio-button :value="false" >No</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-row :gutter="24">
            <a-col :span="getScreen ? 24 : 12">
              <a-form-item label="Date of Invoice" >
                <a-date-picker v-decorator="['date_invoice',{rules: [{ required: true }],
                initialValue: initialData.informasi.date_of_invoice }]" 
                :format="getDefaultDateFormat"
                  ref="date_invoice"
                disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="getScreen ? 24 : 12">
              <a-form-item >
                <span slot="label">Due Date ( {{ dateCalculation }} day/s )</span
                >
                <a-date-picker v-decorator="['dueDate',{rules: [{ required: true }],initialValue: initialData.informasi.dueDate}]"
                :format="getDefaultDateFormat"
                  ref="dueDate" @change="dueDateChange"
                disabled/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Credit Card" v-if="initialData.informasi.id_user_cc">
            <a-select
              v-decorator="['id_user_cc', {rules: [{required: true}], initialValue: initialData.informasi.id_user_cc}]"
              disabled
            >
              <a-select-option
                v-for="item in CClist"
                :key="item.id_user_cc"
                :value="item.id_user_cc"
              >{{item.no_cc}} | {{item.tlc}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Description">
            <a-input v-decorator="['description',{rules: [{ required: true }],initialValue: initialData.informasi.description}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Note">
            <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="[
                'note',
                { rules: [{ required: true }],initialValue: initialData.informasi.note },
              ]"
            />
          </a-form-item>
          <!-- <a-form-item label="Currency To">
              <a-select
                      showSearch
                      v-model="currency_to"
                      :loading="loading_list_mata_uang"
                      :disabled="loading_list_mata_uang"
                      @change="handleCurrency"
              >
                <a-select-option
                        v-for="item in getAllMataUang"
                        :key="item.code"
                        :value="item.code"
                >{{item.code}} - {{item.currency}}</a-select-option>
              </a-select>
          </a-form-item>
          <a-form-item >
            <span slot="label">Exchange Rate 1,00 {{default_mata_uang}} to {{currency_to}}</span>
            <a-input-number
                    :disabled="default_mata_uang==currency_to"
              v-decorator="['rate',{ rules: [{ required: true }],initialValue: initialData.informasi.rate }]"
            ></a-input-number>
          </a-form-item> -->
          <a-form-item label="File Document">
            <a-upload
              :fileList="fileList"
              v-decorator="[
                'file_document',
                { rules: [{ required: true,validator: doc_validation }]},
              ]"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
            >
              <a-button>
                <a-icon type="upload" />Select File
              </a-button>
            </a-upload>
          </a-form-item>
          <!-- <a-form-item label="Value"
          :help="labeling.label"
          >
            <a-input
                    v-decorator="['value',{ rules: [{ required: true }],initialValue: 1 }]"
                    @keydown="onlyNumber"
                    @change="changelabeling"
            ></a-input>
          </a-form-item>
          <a-form-item label="Note">
            <a-input
              v-decorator="[
                'note',
                {
                  rules: [{ required: true }],
                },
              ]"
            ></a-input>
          </a-form-item> -->

        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
export default {
  name: "Informasi",
  props: [
    "parentListPurchasing",
    "data",
    "persetujuan",
    "projectAllsts",
    "mode",
    "id",
    "jenis_transaksi",
    "requirementData",
    "CClist"
  ],
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.fileList.length==0) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      peruntukan: [],
      subPeruntukan: [],
      anggaran: [],
      no_po_wo:[],
      costCenter:[],
      modalanggaran: {
        visible: false,
        enabled: false,
        loadingButton:false,
        value: undefined,
        tree: {},
        searchValue: ""
      },
      isLoading:{
        noPoWo: false,
      },
      loadUserfor:false,
      disabledUserfor:true,
      jenisTransaksi: undefined,
      no : "",
      ppDetail : [],
      currency_to:"IDR",
      default_mata_uang:"IDR",
      default_kurs:1,
      loadPpdetail: false,
      list_mata_uang: [],
      list_mata_uang_to: [],
      loading_list_mata_uang: false,
      labeling:{
        label:undefined,
        value:undefined,
      },
      dateCalculation: 0,
      fileList: [],
      triggered: {
        disabledpowo: true,
      },
      //requirementData:[],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  watch: {
    matauang() {
      if (this.no) {
        this.getList_mata_uang();
      }
    },
    requirementData(){
      if(this.requirementData){
        this.setinit();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAuth",
      "getAllMataUang",
      "getScreen"
    ]),
    initialData() {
      let informasi = {};
      if (this.data === undefined || this.data.length == 0) {
        informasi = {
          id_invoice_ap_ad: undefined,
          date_of_addendum: moment(),
          jns_transaksi: 'po',
          no: null,
          name_supplier: undefined,
          id_supplier: undefined,
          currency_from: undefined,
          account_bank: undefined,
          no_invoice: undefined,
          no_tracking: undefined,
          date_of_invoice: undefined,
          dueDate: undefined,
          note: undefined,
          description: undefined,
          mata_uang: "IDR",
          rate: 1,
          fileList: [],
          pib: false
        };
        return { informasi };
      } else {
        //this.handlePeruntukan(this.data.peruntukan);
        //this.handleSubPeruntukan(this.data.sub_peruntukan);
        //this.handleCodeAnggarn(this.data.kode_anggaran)
        //this.handleCost(this.data.cost_center)
        informasi = {
          date_of_addendum: moment(),
          date_of_invoice: moment(this.data.date_of_invoice),
          id_invoice_ap_ad: this.data.id_invoice_ap_ad,
          jns_transaksi: this.data.jns_transaksi,
          no: this.jenis_transaksi ? this.data.no : this.data.no_po_wo,
          supplier: this.data.supplier,
          id_supplier: this.data.id_supplier,
          currency_from: this.data.currency_from,
          account_bank_number: this.data.account_bank_number,
          no_invoice: this.data.no_invoice,
          no_invoice_ap_ad: this.data.no_invoice_ap_ad,
          no_tracking: this.data.no_tracking,
          dueDate: moment(this.data.due_date),
          description: this.data.description,
          note: this.data.note,
          // currency_to: this.data.currency_to,
          // rate: this.data.rate,
          mata_uang: this.data.currency_from,
          rate: this.data.rate ? this.data.rate : 1,
          fileList: this.data.fileList ? this.data.fileList : [],
          pib: this.data.pib,
          id_user_cc: this.data.id_user_cc
        };
        this.setdefaultmatauang(this.data.currency_from);
        if(this.data.fileList)
          this.setdefaultfile(informasi.fileList);
        return { informasi };
      }
    },
  },
  created() {
    
  },
  methods: {
    moment,
    async handleJenisTransaksi(val){
      this.no_po_wo = [];
      this.no = "";
      this.jenisTransaksi = val.target.value;
      this.currency_to = "IDR";
      if(this.jenis_transaksi){
        this.$nextTick(function () {
          this.form.setFieldsValue({
              note: "",
              description: "",
              rate: 1,
              value: 1
          });
        });
      }
      this.list_mata_uang = [];
      this.peruntukan = [];
      
      
      axios({
        method: "get",
        url: this.$serviceUrl + "addendum/no_transaksi",
        params: {
          jenis_transaksi: val.target.value,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((response) => {
        this.isLoading.noPoWo = false;
        this.no_po_wo = response.data.no_transaksi;

        if(this.mode=="Create" && this.id){
          let tno = _.filter(this.no_po_wo,(el) => el.id_transaksi==this.id);
          this.no = tno[0];
        }
        // else{
        //   if(this.data){
        //     this.no = this.data.no_po_wo;
        //   }
        // }

      }).catch((err) => {
        let response = Object.assign({}, err.response);
        console.log(response);
        this.isLoading.noPoWo = false;
      });
    },
    handleCodeAnggarn(e){
      let forms = this.form.getFieldsValue();
      this.modalanggaran.value = forms.peruntukan+";"+forms.sub_peruntukan+";"+e
    },
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(val){
      if (val){
        let kod = val.split(";")
        this.$nextTick(function () {
          //this.handlePeruntukan(kod[0]);
          this.form.setFieldsValue({
              peruntukan: kod[0],
          });
          //this.handleSubPeruntukan(kod[1]);
          this.form.setFieldsValue({
              sub_peruntukan: kod[1],
              kode_anggaran: kod[2]
          });
        });
      }else{
        this.$nextTick(function () {
          this.form.setFieldsValue({
              peruntukan: undefined,
              sub_peruntukan: undefined,
              kode_anggaran: undefined
          });
        });
      }
      this.modalanggaran.visible = false
    },
    showChoiceModal(){
      this.modalanggaran.visible = true
    },
    handleNoPoWo(item) {
      this.form.resetFields(["currency","value","rate"]);
      this.ppDetail = [];
      this.loadPpdetail = true;
      this.loading_list_mata_uang = true;
      this.list_mata_uang = [];

      if(!this.jenis_transaksi){
        this.form.setFieldsValue({ 
          id_supplier: item.id_supplier,
          name_supplier: item.supplier});
      }

      axios({
        method: "get",
        url: this.$serviceUrl + "addendum/pp_detil",
        params: {
          jenis_transaksi: this.jenisTransaksi,
          id_transaksi: item.id_transaksi
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.peruntukan = response.data.no_transaksi;
          Event.$emit("updateAddendumPPdtl", response.data.no_transaksi);
          this.changelabeling(undefined)
          this.loadPpdetail = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          console.log(responses)
          this.loadPpdetail = false;
        });

      axios({
        method: "get",
        url: this.$serviceUrl + "mata_uang",
        params: this.jenis_transaksi ? {
          default_currency: item.currency,
        }: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((response) => {
        this.loading_list_mata_uang = false;
          this.form.setFieldsValue({ rate: 1 });
          this.default_mata_uang = item.currency;
          this.currency_to = item.currency;
          this.default_kurs = item.kurs;
        
        if(!this.jenis_transaksi){
          // this.list_mata_uang_to = response.data.data;
          this.list_mata_uang = response.data.data;
          //this.form.setFieldsValue({ currency_from: item.currency });
          
          Event.$emit("addendumGenAddRequirement", {
            id: item.id_transaksi,
            data_po_wo: [...this.no],
            pp_dtl: this.peruntukan,
            jenis_transaksi: this.jenisTransaksi,
          });
        }
      }).catch((err) => {
        this.loading_list_mata_uang = false
        let responses = Object.assign({}, err.response);
        console.log(responses)
        this.isLoading.noPoWo = false;
      });
    },
    // handlePeruntukan(e) {
    //   this.modalanggaran.value = undefined;
    //   this.form.resetFields(["sub_peruntukan", "kode_anggaran"]);
    //   this.anggaran = [];
    //   const filter = this.getSubPeruntukan.filter(
    //     (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
    //   );
    //   this.subPeruntukan = filter;
    // },
    handleRef() {
      if(this.fileList.length==0){
        this.displayMessage("form-warning");
      }else{
        this.submite();
      }
    },
    submite() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(this.moment(values.date_of_addendum).format('YYYY-MM-DD')>this.moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Date of Addendum can't exceed today!");
          return;
        }

        // if(parseFloat(values.value)<=0){
        //   this.displayMessageValue("error-other","The values must be grather than 0 !");
        //   return;
        // }

        const dataValues = {
          ...values,
          currency_to: this.currency_to,
          //no_po_wo: this.no,
          fileList: this.fileList,
          rate: 1,
          //ppdtl : this.requirementData.pp_dtl,
        };

        // Event.$emit("save", {
        //   informasi: dataValues,
        // });

        Event.$emit("addendumEmitChild", {
          informasi: dataValues,
        });
      });
    },
    handleCurrency(item){
      if(item == this.default_mata_uang){
        this.form.setFieldsValue({ rate: 1 });
        this.changelabeling(undefined)
      }else{
        this.form.setFieldsValue({ rate: this.default_kurs });
        this.changelabeling(this.labeling.value)
      }
    },
    changelabeling(val){
      let nominal = (val!==undefined && val.target) ? val.target.value : val
      let kurs = this.currency_to == this.default_mata_uang ? 1 : parseFloat(this.default_kurs)
      if (nominal=="" || nominal==undefined){
        this.labeling.label = undefined
      }else{
        this.labeling = {
          label: "converting value : "+
            this.formatCurrency(this.default_mata_uang,parseFloat(nominal)/parseFloat(kurs)),
          value: nominal
        }
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    dueDateChange(val){
      this.fdateCalculation(val);
    },
    fdateCalculation(val) {
      if (this.$refs.dueDate){
        const today = this.moment().format(this.getDefaultDateFormat);
        const dueDate = this.moment(val ? val : null).format(
          this.getDefaultDateFormat
        );

        const todayFormated = this.moment(today ? today: null, this.getDefaultDateFormat);
        const dueDateFormated = this.moment(dueDate ? dueDate : null, this.getDefaultDateFormat);
        const calc = dueDateFormated.diff(todayFormated, "days");
        this.dateCalculation = calc;
      }else{
        this.dateCalculation = 0;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    handleRemove() {
        // const index = this.fileList.indexOf(file);
        // const newFileList = this.fileList.slice();
        // newFileList.splice(index, 1);
        // this.fileList = newFileList;
        this.fileList = [];
    },
    async getRequrementData(id,jenis_transaksi){
      Event.$emit("addendumOnLoadingPage", true);
       await this.asyncAxiosGet(
            "addendum/data_transaction",
            this.getAuth,
            { 
              jenis_transaksi: jenis_transaksi,
              id_transaksi: id
            }
        ).then((response) => {
            this.requirementData = response;
            
            this.triggered.disabledpowo = true;
            this.jenisTransaksi = jenis_transaksi;
            this.no_po_wo = [{
              currency: this.requirementData.data_po_wo[0].currency_from,
              id_transaksi: jenis_transaksi=="PO" ? this.requirementData.data_po_wo[0].id_po : 
                this.requirementData.data_po_wo[0].id_wo,
              kurs:"1",
              no_transaksi: this.requirementData.data_po_wo[0].no_po_wo
            }];
            this.no = this.no_po_wo;
            this.initialData.informasi.id_supplier = this.requirementData.data_po_wo[0].id_supplier;
            this.initialData.informasi.name_supplier = this.requirementData.data_po_wo[0].supplier;
            //this.initialData.informasi.currency_from = this.requirementData.data_po_wo[0].currency_from;
            this.initialData.informasi.jns_transaksi = jenis_transaksi.toLowerCase();
            // this.list_mata_uang_to = this.requirementData.currency;
            Event.$emit("addendumOffLoadingPage", true);
        }).catch((err) => {
            Event.$emit("addendumOffLoadingPage", true);
            console.log(err);
        });
    },
    setinit(){
      this.triggered.disabledpowo = this.jenis_transaksi ? true : false;
        //this.jenisTransaksi = jenis_transaksi;
        
        //this.no_po_wo = [{
        if(this.jenis_transaksi){
          let ass= [{
            currency: this.data.currency,
            id_transaksi: this.data.id_invoice,
            kurs:"1",
            no_transaksi: this.data.no_transaksi,
            id_supplier: this.data.id_supplier,
            supplier:this.data.supplier,
          }];
          this.no = ass;
          this.no_po_wo = ass;
        }
        this.initialData.informasi.id_supplier = this.data.id_supplier;
        this.initialData.informasi.name_supplier = this.data.supplier;
        this.initialData.informasi.currency_from = this.data.currency_from;
        this.initialData.informasi.jns_transaksi = this.jenis_transaksi ? this.jenis_transaksi.toLowerCase() : this.jenis_transaksi;
        // this.list_mata_uang_to = this.requirementData.currency;
        //this.list_mata_uang = this.requirementData.currency;
    },
    setdefaultfile(file){
      this.fileList = file
    },
    setdefaultmatauang(val) {
      this.default_mata_uang = val;
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.submit);
    this.$store.dispatch("FETCH_ALL_MATA_UANG");

    //this.no= (this.id ? this.id : undefined);
    if(this.data){
      this.fileList = this.data.fileList;
      this.currency_to = this.data.currency_to;
      this.default_mata_uang = this.data.currency_from;
    }

    // harusnya check id
    if(this.mode === 'Create'){
      if (this.jenis_transaksi){
        //this.getRequrementData (this.id,this.jenis_transaksi);
        if(this.requirementData && this.requirementData.data_po_wo){
          this.setinit();
        }
      }else{
        let d={target:{value:(this.data ? this.data.jns_transaksi : 'po')}};
        this.jenisTransaksi = this.data ? this.data.jns_transaksi : 'po';
        this.handleJenisTransaksi(d);
        
        if(this.data){
          this.no = this.data.no_po_wo;
        }
      }
    }else{
      //this.list_mata_uang_to = this.requirementData.currency;
      this.no_po_wo = this.requirementData.data_po_wo;
      this.no = this.data.no_po_wo;
    }
    if(this.parentListPurchasing && this.parentListPurchasing.length>0){
      this.triggered.disabledpowo = true;
    }else{
      this.triggered.disabledpowo = this.mode=='Create' && !this.jenis_transaksi ? false : true;
    }
    this.list_mata_uang = this.getAllMataUang;
    this.list_mata_uang_to = this.getAllMataUang;
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
  },

};
</script>

<style lang="less">
.ant-select-selection-selected-value{
  width: 100%
}
</style>
